module.exports = __webpack_public_path__ + "img/labmemtest_logo_en.47b9ffa9.png";